import { StyleSetup } from "../style";

export enum REGISTER_MODE {
    QR = "QR",
    PHONE = "Phone"
}

export enum REGISTER_MODE_BC {
    QR = "QR",
    PHONE = "MOBILE PHONE"
}

export enum AUTHEN {
    BASIC = "Basic",
    OAUTH = "OAuth"
}

export enum CONNECTION {
    BC = "BC",
    WEB = "WEB",
    OTP = "OTP"
}

export enum OTPINSERT_LOG_TYPE {
    REGISTER_MEMBER = "Register Member",
    CHANGE_MOBILE_PHONE = "Change Mobile Phone No.",
    REDEEM_POINT = "Redeem Point"
}

export type InitialConfig = {
    logo: string;
    styles: StyleSetup;
    club_code: string;
}

export type Tabbar = "redeem_point" | "history" | "promotion" | "my_coupon"; 

export enum CouponType {
    REDEEM = "Redeem",
    PROMOTION = "Promotion"
}

export enum CouponEntry {
    OPEN = "Open",
    APPLIED = "Applied"
}

export type RegisterInfo = {
    mode?: REGISTER_MODE;
    value?: string;
}


